import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StudentProfile } from './student-profile';
import { StudentActionRequired } from './student-action-required';

@Injectable({
  providedIn: 'root'
})
export class StudentProfileService {
    verifiedStudentId$: BehaviorSubject<string | null> = new BehaviorSubject(null);

    private readonly routePrefix: string = 'api/studentProfile';
    constructor(private http: HttpClient) { }

    getStudentProfile = (userId?: string | null) =>
        this.http.get<StudentProfile>(`${this.routePrefix}/${userId}`)

    getProfileActionRequiredStatus = (userId: string | null) =>
        this.http.get<StudentActionRequired>(`${this.routePrefix}/actionrequired/${userId}`)
}
